export const onstreetCommonMarkerDataSelector = ({onstreetCommonMarkerData}) => onstreetCommonMarkerData